import { Form, Input } from 'antd';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import SectionV2 from '../components/SectionV2';
import Box from 'components/Box';
import HTMLEditor from './HtmlEditor';
import ActionButtons from '../components/ActionButtons';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { IResponseDataBody } from 'services/response';
import shopApis from 'services/shop/apis';
import toast from 'utils/toast';
import { get } from 'lodash';
import { useAppDispatch } from 'store/hooks';
import shopActions from 'services/shop/actions';
import shopSelectors from 'services/shop/selectors';

const TabConsentForm = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm<any>();
  const setLoading = useSetLoadingPage();

  const agreementData = shopSelectors.data.agreementData();

  useEffect(() => {
    form.setFieldsValue(agreementData || {});
  }, [agreementData]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const res: IResponseDataBody<any> = await shopApis.updateAgreementConsentForm(values);
      if (res.data.data) {
        dispatch(shopActions.get.agreementConsentForm.success(res.data.data));
        toast.success('Success');
      }
    } catch (error) {
      const msg = get(error, 'response.data.message');
      toast.error(msg || '');
    } finally {
      setLoading(false);
    }
  };

  return (
    <TaxStyled>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ saleTaxPercent: 0, useTaxPercent: 0 }}
      >
        <FormV2Container>
          <SectionV2>
            <Form.Item
              style={{ alignSelf: 'stretch' }}
              name="confirmInfo"
              label='Checkbox Information'
            >
              <Input.TextArea rows={4} placeholder='Consent & Agreement' />
            </Form.Item>
            <Form.Item name="agreement" label='Consent & Agreement' style={{ alignSelf: 'stretch' }}>
              <HTMLEditor />
            </Form.Item>
          </SectionV2>
          <ActionButtons />
        </FormV2Container>
      </Form>
    </TaxStyled>
  );
};

export default TabConsentForm;

const TaxStyled = styled.div`
  flex-grow: 1;
  border-radius: 5px;
  .ant-input-number-input-wrap {
    height: 100%;
    input {
      color: #1d2129;
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  background: unset;
`;
const FormV2Container = styled.div`
  background: #fff;
  padding: 16px;
  .ant-input {
      color: #1D2129;
      font-family: Poppins;
      font-size: 24px !important;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
  }
  .ant-form-item-label label {
    color: #1D2129;
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

